import React, {Fragment} from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'

import ModalCreateCompraDirecta from './ModalCreateCompraDirecta'
import ModalSelectorFromList from '../../components/Shared/ModalSelectorFromList'
import ModalConfirmarAccion from '../../components/Shared/ModalConfirmarAccion'
import BoxButton from '../Layout/BoxButton';

import { displayModalCompraDirecta } from '../../actions/solicitudbi'
import { downloadFile } from '../../actions/common'

import { isAllowedToViewComponent, getDivisa, formatcoin } from '../../utils/helpers'

class CompraDirecta extends React.Component {


    render() {
        const { id, solicitudBI, divisas, displayModalCompraDirecta } = this.props
        const medios_pago = {
            tarjeta_debito: 'Tarjeta Débito',
            tarjeta_credito: 'Tarjeta Crédito',
            caja_menor: 'Caja Menor'
        }
        if (!id) return null

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <table className="table table-condensed table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Producto</th>
                                    <th>Cantidad</th>
                                    <th>Nombre razon social</th>
                                    <th>NIT</th>
                                    <th>No. Factura</th>
                                    <th>Fecha compra</th>
                                    <th>Forma de pago</th>
                                    <th>Valor compra</th>
                                    <th>Adjuntar factura</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    solicitudBI.get('cotizaciones').filter(c => c.get('recomendado') && !c.get('proveedor_id')).map((cot) => {

                                        const moneda = cot.get('moneda');
                                        const divisa = getDivisa(divisas, moneda) 
                                        
                                        return cot.get('bienes').filter(bien => bien.get('compra_directa')).map(a =>
                                        (
                                            <tr key={`tr4[${a.get('id')}]`}>
                                                <td style={{ padding: '0' }}>
                                                    <BoxButton 
                                                        size={ 12 } 
                                                        name="pencil" 
                                                        disabled={!!a.getIn(['factura_compra_directa', 'id']) || !isAllowedToViewComponent('responsable_compras', this.props.solicitudBI)}
                                                        onClick={() => displayModalCompraDirecta(true, 'Registrar Compra Directa', a.get('id'), cot)} 
                                                    />
                                                </td>
                                                <td>{a.get('descripcion')}</td>
                                                <td style={{ textAlign: 'right' }}>{a.getIn(['cantidad_solicitada'])}</td>
                                                <td>{a.getIn(['factura_compra_directa', 'razon_social']) || cot.get('proveedor_nombre_cp') || ''}</td>
                                                <td>{a.getIn(['factura_compra_directa', 'nit'])}</td>
                                                <td style={{ textAlign: 'right' }}>{a.getIn(['factura_compra_directa', 'no_factura'])}</td>
                                                <td>{moment(a.getIn(['factura_compra_directa', 'fecha_compra'])).format('YYYY-MM-DD')}</td>
                                                <td>{medios_pago[a.getIn(['factura_compra_directa', 'medio_pago'])]}</td>
                                                <td>{formatcoin(a.getIn(['factura_compra_directa', 'valor_compra']), divisa.simbolo)}</td>
                                                {
                                                    a.getIn(['factura_compra_directa', 'adjunto_id']) ? (
                                                        <td style={{ cursor: 'pointer' }} onClick={() => this.props.downloadFile(a.getIn(['factura_compra_directa', 'adjunto', 'id']), a.getIn(['factura_compra_directa', 'adjunto', 'nombre']))}>
                                                            <i className="fa fa-download"></i>
                                                            <span style={{ marginLeft: '3px' }}>{`${a.getIn(['factura_compra_directa', 'adjunto', 'nombre'])}`}</span>
                                                        </td>
                                                    ) : (
                                                        <Fragment>
                                                            {a.getIn(['factura_compra_directa', 'adjunto']) ? (                                                                
                                                                <td>
                                                                    <span style={{ marginLeft: '3px' }}>{`${a.getIn(['factura_compra_directa', 'adjunto', 'nombre'])}`}</span>
                                                                </td>
                                                            ):(
                                                                <td style={{ cursor: 'not-allowed' }}>
                                                                    <span style={{ marginLeft: '3px' }}>Archivo sin adjuntar</span>
                                                                </td>
                                                            )}
                                                        </Fragment>
                                                    )
                                                }
                                            </tr>
                                        ))
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <ModalCreateCompraDirecta displayModalAddFile={ this.props.displayModalAddFile } />
                <ModalSelectorFromList />
                <ModalConfirmarAccion />
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        id: state.solicitudBI.get('id'),
        solicitudBI: state.solicitudBI.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalCompraDirecta: (show, title, bien_id, cotizacion) => dispatch(displayModalCompraDirecta(show, title, bien_id, cotizacion)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompraDirecta)


// WEBPACK FOOTER //
// ./src/components/SolicitudBI/CompraDirecta.jsx